// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"71252a0f","147":"48198676","362":"c379f500","574":"6c85020d","807":"3a69a4fa","818":"cf0e0c21","899":"8d01e95b","900":"815301c4","959":"60b78cf1","996":"be9260a8"}[chunkId] + ".chunk.js";
};